import React, { FC } from 'react'
import { IconBaseProps } from 'react-icon-base'
import { StyledIcon } from '.'

export const CsCheckIcon: FC<IconBaseProps> = (props) => (
  <StyledIcon viewBox="0 0 1024 1024" {...props}>
    <g>
      <path d="M954.857 332.572q0 22.857-16 38.857L447.428 862.858q-16 16-38.857 16t-38.857-16L85.143 578.287q-16-16-16-38.857t16-38.857l77.714-77.714q16-16 38.857-16t38.857 16l168 168.571 374.857-375.429q16-16 38.857-16t38.857 16l77.714 77.714q16 16 16 38.857z" />
    </g>
  </StyledIcon>
)

CsCheckIcon.displayName = 'CsCheckIcon'
